/* Instinct Pad Advertorial — interactive behaviour
 * FAQ accordion + smooth scroll for anchor links.
 * Self-initialising, idempotent.
 */
(function () {
  if (window.__instAdvertorialInit) return;
  window.__instAdvertorialInit = true;

  // FAQ accordion
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.in-faq-q');
    if (!btn) return;
    var item = btn.closest('.in-faq-item');
    if (!item) return;
    var isOpen = item.classList.toggle('is-open');
    btn.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
  });

  // Smooth scroll for in-scope anchor links
  document.addEventListener('click', function (e) {
    var link = e.target.closest('.inst-scope a[href^="#"]');
    if (!link) return;
    var href = link.getAttribute('href');
    if (!href || href === '#') return;
    var target = document.querySelector(href);
    if (!target) return;
    e.preventDefault();
    target.scrollIntoView({ behavior: 'smooth', block: 'start' });
  });
})();

/* ===========================================================
   Bundle selection — clickable cards + synced CTAs.
   - Click any .in-bundle card to "select" it
   - The selected card gets visual highlight (.is-selected)
   - The bundles section CTA updates: "Get [Name] — [Price]"
   - The final-cta section's bundle preview AND CTA mirror the selection
   =========================================================== */
(function () {
  if (window.__instBundleSelectInit) return;
  window.__instBundleSelectInit = true;

  function readBundleData(card) {
    if (!card) return null;
    var nameEl = card.querySelector('h4');
    var priceEl = card.querySelector('.in-bundle-price');
    var subEl = card.querySelector('.in-bundle-sub');
    var saveEl = card.querySelector('.in-bundle-save');
    var strikeEl = card.querySelector('.in-bundle-strike');
    var featuresEl = card.querySelector('.in-bundle-features');

    // Price text excluding the strike
    var priceText = '';
    if (priceEl) {
      var clone = priceEl.cloneNode(true);
      var s = clone.querySelector('.in-bundle-strike');
      if (s) s.remove();
      priceText = (clone.textContent || '').trim();
    }
    var compareAt = strikeEl ? strikeEl.textContent.trim() : '';

    return {
      name: nameEl ? nameEl.textContent.trim() : '',
      sub: subEl ? subEl.textContent.trim() : '',
      price: priceText,
      compareAt: compareAt,
      save: saveEl ? saveEl.textContent.trim().replace(/^—\s*|\s*—$/g, '').trim() : '',
      featuresHtml: featuresEl ? featuresEl.innerHTML : '',
    };
  }

  function inferPadCount(bundle) {
    // Try sub text first (e.g. "3 Bondi Bark Pads")
    var m = (bundle.sub || '').match(/(\d+)/);
    if (m) return parseInt(m[1], 10);
    // Try name fallback
    if (/family/i.test(bundle.name)) return 3;
    if (/whole/i.test(bundle.name)) return 6;
    return 1;
  }

  function updateBundlesSectionCta(bundle, sourceCard) {
    if (!sourceCard) return;
    var section = sourceCard.closest('.inst-section') || sourceCard.closest('section');
    if (!section) return;
    var cta = section.querySelector('.in-cta-block .in-cta-button, .in-cta-button');
    if (cta) {
      cta.textContent = 'Get The ' + bundle.name + ' — ' + bundle.price;
    }
  }

  function updateFinalCta(bundle) {
    var finalBundle = document.querySelector('.in-final-bundle');
    if (!finalBundle) return;

    // Update name
    var h4 = finalBundle.querySelector('h4');
    if (h4) h4.textContent = bundle.name + ' — ' + bundle.sub;

    // Update price + strike
    var priceEl = finalBundle.querySelector('.in-bundle-price');
    if (priceEl) {
      priceEl.innerHTML = bundle.price +
        (bundle.compareAt ? ' <span class="in-bundle-strike">' + bundle.compareAt + '</span>' : '');
    }

    // Update save line (without leading/trailing dashes)
    var saveEl = finalBundle.querySelector('.in-bundle-save');
    if (saveEl) saveEl.textContent = bundle.save;

    // Update features
    var feats = finalBundle.querySelector('.in-bundle-features');
    if (feats && bundle.featuresHtml) feats.innerHTML = bundle.featuresHtml;

    // Update CTA button text — "Get N Pads for $X →"
    var btn = finalBundle.querySelector('.in-cta-button');
    if (btn) {
      var n = inferPadCount(bundle);
      btn.textContent = 'Get ' + n + (n === 1 ? ' Pad' : ' Pads') + ' for ' + bundle.price + ' →';
    }
  }

  function selectCard(card) {
    if (!card) return;
    var allCards = document.querySelectorAll('.in-bundle');
    allCards.forEach(function (c) {
      c.classList.remove('is-selected');
      c.classList.remove('is-popular'); // un-set the default popular hint
      c.setAttribute('aria-checked', 'false');
    });
    card.classList.add('is-selected');
    card.setAttribute('aria-checked', 'true');

    var bundle = readBundleData(card);
    if (!bundle) return;
    updateBundlesSectionCta(bundle, card);
    updateFinalCta(bundle);
  }

  function init() {
    var cards = document.querySelectorAll('.in-bundle');
    if (!cards.length) return;

    cards.forEach(function (card) {
      card.setAttribute('role', 'radio');
      card.setAttribute('tabindex', '0');
      card.style.cursor = 'pointer';

      card.addEventListener('click', function () { selectCard(card); });
      card.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          selectCard(card);
        }
      });
    });

    // Mark the bundles container with role=radiogroup
    var groups = document.querySelectorAll('.in-bundles');
    groups.forEach(function (g) { g.setAttribute('role', 'radiogroup'); });

    // Default selection: prefer the .is-popular card if present, else the middle one
    var defaultCard = document.querySelector('.in-bundle.is-popular') || cards[Math.floor(cards.length / 2)];
    if (defaultCard) selectCard(defaultCard);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
